import React from "react";
import { styled } from "../../../../stitches.config";
import { ReactComponent as BackgroundInnEmpty } from "../../../../redesign/assets/innpolandRedesign/footer-inn-empty-gray.svg?react"

const DotsHeader = () => (
    <>
        <BackgroundLogo className="inn-background-logo">
            <BackgroundInnEmpty />
        </BackgroundLogo>
    </>
);

const BackgroundLogo = styled("div", {
    position: "absolute",
    right: "-48px",
    bottom: "-48px",
    height: "250px",
    width: "250px",
    display: "none",
    "@bp5": {
        display: "block",
    },
    "svg": {
        stroke: "$primary",
        transform: "rotate(-90deg)",
    },
});

export default DotsHeader;

